/**
 * @file
 * Karhu Helsinki theme javascripts
 */

(function ($, Drupal) {

  "use strict";

  Drupal.behaviors.some_feed = {

    attach: function(context, settings) {

      if($('#block-karhusuitesocialmediafeed, #block-karhusuitesocialmediafeed-2').length) {
        var $grid = $('#block-karhusuitesocialmediafeed .feed-items, #block-karhusuitesocialmediafeed-2 .feed-items');
        $grid.imagesLoaded().progress(function() {
          $grid.masonry({
            itemSelector: '.some-item',
            columnWidth: '.some-item',
            gutter: '.gutter-sizer',
            percentPosition: true
          });
        });
      }

    }
  };

})(jQuery, Drupal);
